import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom'
import Routes from '../../../routes'
import Load3rdPartyScripts from '../../../load3rdPartyScripts';
import { isMobile } from 'mobile-device-detect';

const styles = StyleSheet.create({
    title: {
        color: '#193f83',
        fontWeight: 700
    },
    bg: {
        backgroundColor: '#d4e8f5',
    },
    cta: {
        outline: '1px solid #06a77d',
        backgroundColor: '#06a77d',
        color: 'white',
        padding: '10px 70px',
        fontWeight: '700',
        fontSize: '20px',
        margin: '10px'

    },
    cta2: {
        outline: '1px solid #06a77d',
        backgroundColor: '#06a77d',
        color: 'white',
        padding: '10px 70px',
        fontWeight: '700',
        fontSize: '20px',

    },
});

class CotizaYa extends Component {

    componentDidMount(){
        Load3rdPartyScripts.Tidio();
    }

    render() {
        return (
            <div className={css(styles.bg)}>
                <Container className="py-5">
                    <Row>
                        <Col xs={12} className="d-flex flex-column justify-content-center align-items-center">
                            <h2 className={css(styles.title)}>Cotiza hoy.</h2>
                            <p className="lead">Cambia la forma en que almacenas tus cosas.</p>
                            <div className={ isMobile ? 'd-flex flex-column justify-content-center align-items-center' : ''}>
                                <a href={Routes.NewRequest.url+"?from=cotizar"} className={css(styles.cta)}>Cotizar</a>
                                <a href={Routes.CotizaAsesor.url} className={css(styles.cta2)+" mt-3"}>Cotizar con asesor</a>
                            </div>
                        
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default CotizaYa;